import { env } from '@polleverywhere/core'

export function waitFor (seconds) {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000))
}

export function railsUrl (path, search = {}) {
  return env.get('api_url').pathname(path).search(search).toString()
}

export function vizUrl (path) {
  return env.get('viz_url').protocol('https').pathname(path).toString()
}
